<div class="header">
  <div class="title" id="SubTitle">{{ title }}</div>

  @if (!shortBreadCrumbs && tabs !== 'customers') {
    <div [ngClass]="{ over: actionTitle === '' }" class="bread" id="Breadcrumb1">
      {{ tenantLabel }} <span class="secondary">/</span> {{ network.name }} <span class="secondary">/</span>
      {{ breadcrumb }}
    </div>
  }
  @if (shortBreadCrumbs) {
    <div [ngClass]="{ over: actionTitle === '' }" class="bread" id="Breadcrumb2">
      <span class="secondary"></span> {{ breadcrumb }}
    </div>
  }
  <div class="line"></div>

  @if (_resourceType && this.showUploadLink()) {
    <div
      (click)="openResourceUploadDialog()"
      class="bread upload-link"
      id="UploadLink"
      >
      {{ uploadText }}
    </div>
  }
  @if (tabs === 'endpoints') {
    <div class="tabs">
      @if (authorizationService.canListEndpoints()) {
        <div
          [ngClass]="{ selected: url === Gateways }"
          [routerLink]="Gateways"
          class="tab"
          id="ManageGatewaysTab"
          >
          Gateways
        </div>
      }
      @if (authorizationService.canListEndpoints()) {
        <div
          [ngClass]="{ selected: url === Clients }"
          [routerLink]="Clients"
          class="tab"
          id="ManageClientsTab"
          >
          Clients
        </div>
      }
      @if (authorizationService.canListAzureVirtualWanSites()) {
        <div
          [ngClass]="{ selected: url === Azure_Virtual_Wan_Sites }"
          [routerLink]="Azure_Virtual_Wan_Sites"
          class="tab"
          id="ManageAzureSitesTab"
          >
          Azure Virtual WAN Sites
        </div>
      }
      @if (authorizationService.canListEndpointGroups()) {
        <div
          [ngClass]="{ selected: url === Groups }"
          [routerLink]="Groups"
          class="tab"
          id="ManageGroupsTab"
          >
          Endpoint Groups
        </div>
      }
    </div>
  }
  @if (tabs === 'appwans') {
    <div class="tabs">
      @if (authorizationService.canListServices()) {
        <div
          [ngClass]="{ selected: url === Services }"
          [routerLink]="Services"
          class="tab"
          id="ManageServicesTab"
          >
          Services
        </div>
      }
      @if (authorizationService.canListAppWans()) {
        <div
          [ngClass]="{ selected: url === Appwans }"
          [routerLink]="Appwans"
          class="tab"
          id="ManageAppWansTab"
          >
          AppWANs
        </div>
      }
    </div>
  }
  @if (tabs === 'networks') {
    <div class="tabs">
      <!--    <div class="tab" *ngIf="!featureService.experimentalFeatures" id="ManageNetworksTab" routerLink="/networks" [ngClass]="{selected:url==='/networks'}">Manage Networks</div>-->
      <div
        [ngClass]="{ selected: url === '/networks' || url === '/networks/list' }"
        class="tab"
        id="ManageNetworksTab1"
        [routerLink]="featureService.betaListRoute('/networks')"
        >
        Networks
      </div>
      <!--    <div-->
      <!--      *ngIf="authorizationService.canListOrganizations()"-->
      <!--      [ngClass]="{ selected: url === '/network-groups' }"-->
      <!--      class="tab"-->
      <!--      id="ManageNetworksGroupTab"-->
      <!--      routerLink="/network-groups"-->
      <!--    >-->
      <!--      Network Groups-->
    <!--    </div>-->
    @if (authorizationService.canListNetworks() && featureService.disableNewNavigation) {
      <div
        [ngClass]="{ selected: url === '/process-executions' || url === '/process-executions/list' }"
        class="tab"
        id="ManageNetworkProcesses"
        [routerLink]="featureService.betaListRoute('/process-executions')"
        >
        Network Processes
      </div>
    }
  </div>
}
@if (tabs === 'network-groups') {
  <div class="tabs">
    @if (authorizationService.canListOrganizations()) {
      <div
        [ngClass]="{ selected: url === '/network-groups' }"
        class="tab"
        id="ManageNetworksGroupTab"
        routerLink="/network-groups"
        >
        Network Groups
      </div>
    }
  </div>
}
@if (tabs === 'processes') {
  <div class="tabs">
    @if (authorizationService.canListNetworks()) {
      <div
        [ngClass]="{ selected: url === '/process-executions' || url === '/process-executions/list' }"
        class="tab"
        id="ManageNetworkProcesses"
        [routerLink]="featureService.betaListRoute('/process-executions')"
        >
        Network Processes
      </div>
    }
  </div>
}
@if (tabs === 'controllers') {
  <div class="tabs">
    @if (authorizationService.canListNetworks()) {
      <div
        [ngClass]="{ selected: url === '/network-controllers' || url === '/network-controllers/list' }"
        class="tab"
        id="ManageNetworkControllers"
        [routerLink]="featureService.betaListRoute('/network-controllers')"
        >
        Network Controllers
      </div>
    }
    @if (authorizationService.canListNetworks() && featureService.isCloudZiti) {
      <div
        [ngClass]="{ selected: isEdgeRoutersTabSelected(url) }"
        class="tab"
        id="ManageEdgeRouters"
        [routerLink]="edgeRoutersTabLink"
        >
        Edge Routers
      </div>
    }
    @if (authorizationService.canListNetworks()) {
      <div
        [ngClass]="{ selected: url === '/allocated-ips' || url === '/allocated-ips/list' }"
        class="tab"
        id="ManageAllocatedIps"
        [routerLink]="featureService.betaListRoute('/allocated-ips')"
        >
        Allocated Ips
      </div>
    }
  </div>
}
@if (tabs === 'operations') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: isTabSelected(url, Network_Operations) }"
      [routerLink]="Network_Operations"
      class="tab"
      id="NetworkOperationsManagement"
      >
      Management
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Network_Operations_Upgrades) }"
      [routerLink]="Network_Operations_Upgrades"
      class="tab"
      id="NetworkOperationsUpgrades"
      >
      Upgrades
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Network_Operations_Backups) }"
      [routerLink]="Network_Operations_Backups"
      class="tab"
      id="NetworkOperationsBackups"
      >
      Backups
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Network_Operations_Support_Info) }"
      [routerLink]="Network_Operations_Support_Info"
      class="tab"
      id="NetworkOperationsSupportInfo"
      >
      Support Info
    </div>
  </div>
}
<!-- The HTTP area of the FD sub-app: the shares, the domain names they are published under, and the providers they log users in with. -->
@if (tabs === 'fd-http') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Http_Shares) }"
      [routerLink]="Fd_Http_Shares"
      class="tab"
      id="FdHttpSharesTab"
      >
      HTTP Shares
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Domain_Names) }"
      [routerLink]="Fd_Domain_Names"
      class="tab"
      id="FdDomainNamesTab"
      >
      Domain Names
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Oidc_Providers) }"
      [routerLink]="Fd_Oidc_Providers"
      class="tab"
      id="FdOidcProvidersTab"
      >
      OIDC Providers
    </div>
  </div>
}
  <!-- The Settings page of the FD sub-app. The AI Assistant tab shows only when the selected Frontdoor's
     network has the AI_ASSISTANT extension; FrontdoorExtensionGuard closes the route the same way. -->
  @if (tabs === 'fd-settings') {
    <div class="tabs">
      <div
        [ngClass]="{ selected: isTabSelected(url, Fd_Settings) }"
        [routerLink]="Fd_Settings"
        class="tab"
        id="FdSettingsTab"
      >
        Settings
      </div>
      @if (fdAiAssistantEnabled) {
        <div
          [ngClass]="{ selected: isTabSelected(url, Fd_Settings_Ai_Assistant) }"
          [routerLink]="Fd_Settings_Ai_Assistant"
          class="tab"
          id="FdSettingsAiAssistantTab"
        >
          AI Assistant
        </div>
      }
    </div>
  }

  <!-- The Operations page of the FD sub-app: one listing per ingress kind. -->
  @if (tabs === 'fd-operations') {
    <div class="tabs">
      <div
        [ngClass]="{ selected: isTabSelected(url, Fd_Operations_Http) }"
        [routerLink]="Fd_Operations_Http"
        class="tab"
        id="FdOperationsHttpTab"
      >
        HTTP Ingress
      </div>
      <div
        [ngClass]="{ selected: isTabSelected(url, Fd_Operations_Mtls) }"
        [routerLink]="Fd_Operations_Mtls"
        class="tab"
        id="FdOperationsMtlsTab"
      >
        mTLS Ingress
      </div>
    </div>
  }

  <!-- The TCP Shares area of the FD sub-app: the listing and the four certificate pages that
       scope the same frontdoor. A real strip, unlike the one below: these five are read
       against one frontdoor, so moving between them is moving around one subject.

       Ungated, like the strip below, and for the same reason. -->
@if (tabs === 'fd-tcp') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Tcp_Shares) }"
      [routerLink]="Fd_Tcp_Shares"
      class="tab"
      id="FdTcpSharesTab"
      >
      TCP Shares
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Tcp_Certificates) }"
      [routerLink]="Fd_Tcp_Certificates"
      class="tab"
      id="FdCertificatesTab"
      >
      Client Certificates
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Tcp_Tokens) }"
      [routerLink]="Fd_Tcp_Tokens"
      class="tab"
      id="FdCertificateRequestTokensTab"
      >
      Certificate Request Tokens
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Tcp_Server_Certificates) }"
      [routerLink]="Fd_Tcp_Server_Certificates"
      class="tab"
      id="FdServerCertificatesTab"
      >
      Server Certificates
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Fd_Tcp_Server_Certificate_Requests) }"
      [routerLink]="Fd_Tcp_Server_Certificate_Requests"
      class="tab"
      id="FdServerCertificateRequestsTab"
      >
      Server Certificate Requests
    </div>
  </div>
}
<!-- The rest of the FD sub-app. Each of these pages draws its own tab and no other, so the
     strip names what is on screen rather than offering a way off it. The sidebar is what
     moves between them.

     Ungated, unlike the alerts strip: the pages are read with the same grant, and each one
     reports an account with no v3 Frontdoor itself. -->
@if (tabs === 'fd') {
  <div class="tabs">
    <!-- The IPsec section is the one FD page with more than one listing, so its entry is a real
         choice rather than a label. Both tabs are the same route, picked by a `tab` query
         parameter, which keeps each listing on its own `''` child route. -->
    @if (fdIpsecTab(url); as ipsecTab) {
      <div
        [routerLink]="Fd_Ipsec"
        [queryParams]="{}"
        [ngClass]="{ selected: ipsecTab === 'shares' }"
        class="tab"
        id="FdIpsecSharesTab"
        >
        Shares
      </div>
      <div
        [routerLink]="Fd_Ipsec"
        [queryParams]="Fd_Ipsec_Tunnels_Tab"
        [ngClass]="{ selected: ipsecTab === 'tunnels' }"
        class="tab"
        id="FdIpsecTunnelsTab"
        >
        IPSec Tunnels
      </div>
    }
    @if (isTabSelected(url, Fd_Agents)) {
      <div
        [routerLink]="Fd_Agents"
        class="tab selected"
        id="FdAgentsTab"
        >
        Agents
      </div>
    }
    @if (isTabSelected(url, Fd_Processes)) {
      <div
        [routerLink]="Fd_Processes"
        class="tab selected"
        id="FdExecutionsTab"
        >
        Processes
      </div>
    }
    @if (isTabSelected(url, Fd_Alerts)) {
      <div
        [routerLink]="Fd_Alerts"
        class="tab selected"
        id="FdAlertsTab"
        >
        Alerts
      </div>
    }
  </div>
}
@if (tabs === 'alerts') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: isTabSelected(url, Alerts) }"
      [routerLink]="Alerts"
      class="tab"
      id="AlertsTab"
      >
      Alerts
    </div>
    @if (authorizationService.canListMutes()) {
      <div
        [ngClass]="{ selected: isTabSelected(url, Mutes) }"
        [routerLink]="Mutes"
        class="tab"
        id="MutesTab"
        >
        Mutes
      </div>
    }
    @if (authorizationService.canListLatencyPolicies()) {
      <div
        [ngClass]="{ selected: isTabSelected(url, Latency_Policies) }"
        [routerLink]="Latency_Policies"
        class="tab"
        id="LatencyPoliciesTab"
        >
        Latency Policies
      </div>
    }
    @if (authorizationService.canListOfflinePolicies()) {
      <div
        [ngClass]="{ selected: isTabSelected(url, Offline_Policies) }"
        [routerLink]="Offline_Policies"
        class="tab"
        id="OfflinePoliciesTab"
        >
        Offline Policies
      </div>
    }
    <!-- The window the Alerts page is read against, floated to the far right of the tab
         line. One control for both sections of that page: the Overview counts and the
         listing are two readings of the same alerts, so they take one window between
         them. Alerts only - neither sibling tab has a time window. -->
    @if (showAlertsTimeRange(url)) {
      <div class="tabs-action">
        <!-- Whatever the Alerts page is offering, to the left of the window. It scopes the
             whole page the same way the window does, so it belongs on the same line and
             not in one of the two sections below. The page owns what it does; this only
             draws it. -->
        @if (alertsHeaderAction.action; as action) {
          <button
            type="button"
            class="tabs-action__button"
            [id]="action.id"
            [disabled]="action.isDisabled()"
            [title]="action.title"
            (click)="action.run()"
            >
            <i [class]="action.iconClass" aria-hidden="true"></i>
            {{ action.label }}
          </button>
        }
        <app-time-range-pill
          [selected]="alertsTimeRange.range"
          [ranges]="alertsTimeRange.options"
          (rangeChange)="alertsTimeRange.set($event)"
        />
      </div>
    }
  </div>
}
@if (tabs === 'settings') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: isTabSelected(url, Network_Settings) }"
      [routerLink]="Network_Settings"
      class="tab"
      id="NetworkSettings"
      >
      Settings
    </div>
    <div
      [ngClass]="{ selected: isTabSelected(url, Network_Settings_Firewall_Info) }"
      [routerLink]="Network_Settings_Firewall_Info"
      class="tab"
      id="NetworkSettingsFirewallInfo"
      >
      Firewall Info
    </div>
    @if (aiAssistantEnabled) {
      <div
        [ngClass]="{ selected: isTabSelected(url, Network_Settings_Ai_Assistant) }"
        [routerLink]="Network_Settings_Ai_Assistant"
        class="tab"
        id="NetworkSettingsAiAssistant"
        >
        AI Assistant
      </div>
    }
  </div>
}
@if (tabs === 'azure') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === '/virtualwans' }" class="tab" id="VirtualWANsTab" routerLink="/virtualwans">
      Virtual WANs
    </div>
  </div>
}
@if (tabs === 'metrics') {
  <div class="tabs">
    @if (authorizationService.canReadElasticSearch()) {
      <div
        [ngClass]="{ selected: url === Metrics }"
        [routerLink]="featureService.isCloudZiti ? CZ_Metrics : Metrics"
        class="tab"
        id="Metrics"
        >
        Metrics
      </div>
    }
    @if (authorizationService.canReadElasticSearch()) {
      <div
        [ngClass]="{ selected: url === Fabric_Latency }"
        [routerLink]="Fabric_Latency"
        class="tab"
        id="FabricLatency"
        >
        Fabric Latency
      </div>
    }
    @if (authorizationService.canReadElasticSearch()) {
      <div
        [ngClass]="{ selected: url === Controller_Latency }"
        [routerLink]="Controller_Latency"
        class="tab"
        id="ControllerLatency"
        >
        Controller Latency
      </div>
    }
    @if (authorizationService.canReadElasticSearch()) {
      <div
        [ngClass]="{ selected: url === Fabric_Latency_Timeouts }"
        [routerLink]="Fabric_Latency_Timeouts"
        class="tab"
        id="FabricLatencyTimeouts"
        >
        Latency Timeouts
      </div>
    }
    @if (authorizationService.canReadElasticSearch()) {
      <div
        [ngClass]="{ selected: url === Traffic_Analysis }"
        [routerLink]="Traffic_Analysis"
        class="tab"
        id="TrafficAnalysis"
        >
        Traffic Analysis
      </div>
    }
  </div>
}
@if (tabs === 'events') {
  <div class="tabs">
    @if (authorizationService.canReadElasticSearch()) {
      <div
        [ngClass]="{ selected: url === Management_Events || url === '/management-events/list' }"
        [routerLink]="featureService.betaListRoute(Management_Events)"
        class="tab"
        id="ManagementEvents"
        >
        Management Events
      </div>
    }
    @if (authorizationService.canReadElasticSearch() && apiService.productFamily === 'ZITI') {
      <div
        [ngClass]="{ selected: url === Network_Events || url === '/network-events/list' }"
        [routerLink]="featureService.betaListRoute(Network_Events)"
        class="tab"
        id="NetworkEvents"
        >
        Network Events
      </div>
    }
    @if (authorizationService.canReadAlarms() && apiService.productFamily !== 'ZITI') {
      <div
        [ngClass]="{ selected: url === Alarms }"
        [routerLink]="Alarms"
        class="tab"
        id="AlarmLogButton"
        >
        Network Alarms
      </div>
    }
    <div
      [ngClass]="{ selected: url === Notifications || url === '/notifications/list' }"
      [routerLink]="featureService.betaListRoute(Notifications)"
      class="tab"
      id="NotificationsButton"
      >
      Notifications
    </div>
  </div>
}
@if (tabs === 'integrations') {
  <div class="tabs">
    @if (authorizationService.canListAzureSubscriptions()) {
      <div
        [ngClass]="{ selected: url === Subscriptions_VWAN }"
        [routerLink]="Subscriptions_VWAN"
        class="tab"
        id="AzureVWSubscriptionTab"
        >
        Endpoint Lifecycle
      </div>
    }
    <!-- <div class="tab" id="AADSubscriptionTab" *ngIf="authorizationService.canListClientSyncs()" [routerLink]="Subscriptions_AAD" [ngClass]="{selected:url===Subscriptions_AAD, disabled:network.id == null}">Azure Active Directory</div>
    <div class="tab" id="ADSubscriptionTab" *ngIf="authorizationService.canListClientSyncs()" [routerLink]="Subscriptions_AD" [ngClass]="{selected:url===Subscriptions_AD, disabled:network.id == null}">Active Directory</div> -->
  </div>
}
@if (tabs === 'scim-integrations') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === '/integrations/scim' || url === '/integrations/scim/list' }"
      [routerLink]="featureService.betaListRoute('/integrations/scim')"
      class="tab"
      id="ScimIntegrationTab"
      >
      SCIM
    </div>
  </div>
}
@if (tabs === 'service-templates') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === '/services' }" routerLink="/services" class="tab" id="ServicesTab">Services</div>
    <div [ngClass]="{ selected: url === '/configs' }" routerLink="/configs" class="tab" id="ConfigurationsTab">Configurations</div>
    <div [ngClass]="{ selected: url === '/config-types' }" routerLink="/config-types" class="tab" id="ConfigTypesTab">Config Types</div>
    <div [ngClass]="{ selected: url === '/terminators' }" routerLink="/terminators" class="tab" id="TerminatorsTab">Terminators</div>
    <div
      [ngClass]="{ selected: url === '/service-templates' || url === '/service-templates/list' }"
      [routerLink]="featureService.betaListRoute('/service-templates')"
      class="tab"
      id="ServiceTemplatesTab"
      >
      Templates
    </div>
  </div>
}
@if (tabs === 'health-checks') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === '/frontdoor/health-checks' }"
      routerLink="/frontdoor/health-checks"
      class="tab"
      id="HealthChecksTab"
      >
      Health Checks
    </div>
  </div>
}
@if (tabs === 'frontends') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === '/frontdoor/frontends' }"
      routerLink="/frontdoor/frontends"
      class="tab"
      id="FrontendsTab"
      >
      Frontends
    </div>
  </div>
}
<!-- v2 has no header tab strip on the frontdoor pages: HTTP / TCP / IPsec Shares
     moved to the left nav's Shares group, and the HTTP shares page carries its own
     Shares / Namespaces / Authentication tabs. Guarding the container itself (not
     just its contents) keeps an empty .tabs from reserving ~3.6rem above them. -->
@if (tabs === 'frontdoor' && !isV2) {
    <div class="tabs">
            <div
            [ngClass]="{ selected: url === '/frontdoor' }"
            routerLink="/frontdoor"
            class="tab"
            id="FrontdoorTab"
            >
            Frontdoor Shares
            </div>
    </div>
}
@if (tabs === 'change-log') {
<div class="tabs">
  <div
      [ngClass]="{ selected: url === '/frontdoor/change-log' }"
      routerLink="/frontdoor/change-log"
      class="tab"
      id="ChangeLogTab"
      >
      Change Log
    </div>
  </div>
}
@if (tabs === 'agents') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === '/frontdoor/agents' }"
      routerLink="/frontdoor/agents"
      class="tab"
      id="AgentsTab"
      >
      Agents
    </div>
  </div>
}

@if (tabs === 'frontdoor-providers') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === '/frontdoor/authentication' }"
      routerLink="/frontdoor/authentication"
      class="tab"
      id="AuthProvidersTab"
      >
      Authentication Providers
    </div>
  </div>
}
@if (tabs === 'certificates') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === '/frontdoor/client-certificates' }"
      routerLink="/frontdoor/client-certificates"
      class="tab"
      id="ClientCertificatesTab"
      >
      Client Certificates
    </div>
    <div
      [ngClass]="{ selected: url === '/frontdoor/certificate-request-tokens' }"
      routerLink="/frontdoor/certificate-request-tokens"
      class="tab"
      id="ScimIntegrationTab"
      >
      Certificate Request Tokens
    </div>
  </div>
}
@if (tabs === 'organization') {
  <div class="tabs">
    @if (
      authorizationService.canUpdateColors() ||
      authorizationService.canDeleteColors() ||
      authorizationService.canUpdateLogos() ||
      authorizationService.canDeleteLogos()
      ) {
      <div
        [ngClass]="{ selected: url === Settings }"
        [routerLink]="Settings"
        class="tab"
        id="OrganizationSettingTab"
        >
        Organization Settings
      </div>
    }
  </div>
}
@if (tabs === 'organizations') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Organizations || url === '/organizations/manage/list' }"
      [routerLink]="featureService.betaListRoute(Organizations)"
      class="tab"
      id="ManageOrganizationsTab"
      >
      Organizations
    </div>
  </div>
}
@if (tabs === 'customers') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Customers }" [routerLink]="Customers" class="tab" id="CustomersTab">
      Customers
    </div>
  </div>
}

@if (tabs === 'namespaces') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Namespaces }" [routerLink]="Namespaces" class="tab" id="ShareTab">
      Namespaces
    </div>
  </div>
}

@if (tabs === 'ipsec-tunnels') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === IpsecTunnels }" [routerLink]="IpsecTunnels" class="tab" id="IpsecTunnelsTab">
      IPsec Tunnels
    </div>
  </div>
}

@if (tabs === 'ipsec-tunnelers') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ipsec_Tunnelers || url === Ipsec_Tunnelers + '/list' }"
      [routerLink]="featureService.betaListRoute(Ipsec_Tunnelers)"
      class="tab"
      id="IpsecTunnelersTab"
      >
      IPsec Tunnelers
    </div>
  </div>
}


@if (tabs === 'billing') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Billing }" [routerLink]="Billing" class="tab" id="ManageBillingTab">
      Billing
    </div>
  </div>
}
@if (tabs === 'app-billing') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Org_Billing }" [routerLink]="App_Billing" class="tab" id="ManageBillingTab">
      Billing
    </div>
  </div>
}
@if (tabs === 'org-billing') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Org_Billing }" [routerLink]="Org_Billing" class="tab" id="ManageBillingTab">
      Billing
    </div>
  </div>
}
@if (tabs === 'support-billing') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Support_Billing }" [routerLink]="Support_Billing" class="tab" id="ManageBillingTab">
      Billing
    </div>
  </div>
}
@if (tabs === 'billing-management') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Payment_Profile }"
      [routerLink]="Payment_Profile"
      class="tab"
      id="PaymentProfileTab"
      >
      Payment Profile
    </div>
    <div
      [ngClass]="{ selected: url === Account_Details }"
      [routerLink]="Account_Details"
      class="tab"
      id="AccountDetailsTab"
      >
      Account Details
    </div>
    @if (!hideSubscriptionsTab) {
      <div
        [ngClass]="{ selected: url === Billing_Subscriptions }"
        [routerLink]="Billing_Subscriptions"
        class="tab"
        id="PageBillingSubscriptionsTab"
        >
        Subscriptions
      </div>
    }
    <div
      [ngClass]="{ selected: url === Billing_Subscription_Usage }"
      [routerLink]="Billing_Subscription_Usage"
      class="tab"
      id="PageBillingSubscriptionUsageTab"
      >
      Data Usage
    </div>
    <div
      [ngClass]="{ selected: url === Billing_Subscription_Usage_Report }"
      [routerLink]="Billing_Subscription_Usage_Report"
      class="tab"
      id="PageBillingSubscriptionUsageReportTab"
      >
      Usage Report
    </div>
    @if (featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === Billing_Subscription_Invoices }"
        [routerLink]="Billing_Subscription_Invoices"
        class="tab"
        id="PageBillingSubscriptionInvoicesTab"
        >
        Invoices
      </div>
    }
  </div>
}
@if (tabs === 'app-billing-management') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Billing_Payment_Profile }"
      [routerLink]="Billing_Payment_Profile"
      class="tab"
      id="PaymentProfileTab"
      >
      Payment Profile
    </div>
    @if (featureService.experimentalFeatures) {
      <div
        [ngClass]="{ selected: url === Billing_Account_Details }"
        [routerLink]="Billing_Account_Details"
        class="tab"
        id="AccountDetailsTab"
        >
        Account Details
      </div>
    }
    <div
      [ngClass]="{ selected: url === App_Billing_Subscription_Usage }"
      [routerLink]="App_Billing_Subscription_Usage"
      class="tab"
      id="PageBillingSubscriptionUsageTab"
      >
      Data Usage
    </div>
    <div
      [ngClass]="{ selected: url === App_Billing_Subscription_Usage_Report }"
      [routerLink]="App_Billing_Subscription_Usage_Report"
      class="tab"
      id="PageAppBillingSubscriptionUsageReportTab"
      >
      Usage Report
    </div>
    @if (featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === App_Billing_Subscription_Invoices }"
        [routerLink]="App_Billing_Subscription_Invoices"
        class="tab"
        id="PageBillingSubscriptionInvoicesTab"
        >
        Invoices
      </div>
    }
  </div>
}
@if (tabs === 'org-billing-management') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Org_Payment_Profile }"
      [routerLink]="Payment_Profile"
      class="tab"
      id="PaymentProfileTab"
      >
      Payment Profile
    </div>
    @if (featureService.experimentalFeatures) {
      <div
        [ngClass]="{ selected: url === Org_Account_Details }"
        [routerLink]="Org_Account_Details"
        class="tab"
        id="AccountDetailsTab"
        >
        Account Details
      </div>
    }
    <div
      [ngClass]="{ selected: url === Org_Billing_Subscription_Usage }"
      [routerLink]="Org_Billing_Subscription_Usage"
      class="tab"
      id="PageBillingSubscriptionUsageTab"
      >
      Data Usage
    </div>
    <div
      [ngClass]="{ selected: url === Org_Billing_Subscription_Usage_Report }"
      [routerLink]="Org_Billing_Subscription_Usage_Report"
      class="tab"
      id="PageOrgBillingSubscriptionUsageReportTab"
      >
      Usage Report
    </div>
    <div
      [ngClass]="{ selected: url === Org_Billing_Subscription_Overages }"
      [routerLink]="Org_Billing_Subscription_Overages"
      class="tab"
      id="PageBillingSubscriptionOveragesTab"
      >
      Overages
    </div>
  </div>
}
@if (tabs === 'support-billing-management') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Support_Payment_Profile }"
      [routerLink]="Support_Payment_Profile"
      class="tab"
      id="PaymentProfileTab"
      >
      Payment Profile
    </div>
    @if (featureService.experimentalFeatures) {
      <div
        [ngClass]="{ selected: url === Support_Account_Details }"
        [routerLink]="Support_Account_Details"
        class="tab"
        id="AccountDetailsTab"
        >
        Account Details
      </div>
    }
    <div
      [ngClass]="{ selected: url === Support_Billing_Subscription_Usage }"
      [routerLink]="Support_Billing_Subscription_Usage"
      class="tab"
      id="PageBillingSubscriptionUsageTab"
      >
      Data Usage
    </div>
    <div
      [ngClass]="{ selected: url === Support_Billing_Subscription_Usage_Report }"
      [routerLink]="Support_Billing_Subscription_Usage_Report"
      class="tab"
      id="PageSupportBillingSubscriptionUsageReportTab"
      >
      Usage Report
    </div>
    <div
      [ngClass]="{ selected: url === Support_Billing_Subscription_Overages }"
      [routerLink]="Support_Billing_Subscription_Overages"
      class="tab"
      id="PageBillingSubscriptionOveragesTab"
      >
      Overages
    </div>
  </div>
}
@if (tabs === 'tokens') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Tokens || url === '/user-identities/tokens/list' }" [routerLink]="featureService.betaListRoute(Tokens)" class="tab" id="ManageAPIAccessTab">
      API Accounts
    </div>
  </div>
}
@if (tabs === 'stored_secrets') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Stored_Secrets || url === '/stored-secrets/list' }" [routerLink]="featureService.betaListRoute(Stored_Secrets)" class="tab" id="ManageAPIAccessTab">
      SSH Keys
    </div>
  </div>
}
@if (tabs === 'oidc_audiences') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === Oidc_Issuers || url === '/oidc-issuers/list' }" [routerLink]="featureService.betaListRoute(Oidc_Issuers)" class="tab" id="ManageOidcIssuersTab">
      Oidc Issuers
    </div>
    <div [ngClass]="{ selected: url === Oidc_Audiences || url === '/oidc-audiences/list' }" [routerLink]="featureService.betaListRoute(Oidc_Audiences)" class="tab" id="ManageAPIAccessTab">
      Oidc Audiences
    </div>
    <div [ngClass]="{ selected: url === Oidc_Identity_Audience_Maps || url === '/oidc-identity-audience-map/list' }" [routerLink]="featureService.betaListRoute(Oidc_Identity_Audience_Maps)" class="tab" id="ManageAudienceMapTab">
      Oidc Identity Audience Maps
    </div>
    <div [ngClass]="{ selected: url === Oidc_Public_Clients}" [routerLink]="Oidc_Public_Clients" class="tab" id="ManagePublicClientsTab">
      Oidc Public Clients
    </div>
    <div [ngClass]="{ selected: url === Oidc_Public_Client_Org_Mapping || url === '/public-client-org-map/list' }" [routerLink]="featureService.betaListRoute(Oidc_Public_Client_Org_Mapping)" class="tab" id="ManageOidcOrgPublicClientTab">
      Oidc Organization to Public Client Map
    </div>
  </div>
}
@if (tabs === 'user') {
  <div class="tabs">
    @if (authorizationService.canListUserIdentities()) {
      <div
        [ngClass]="{ selected: url === User }"
        [routerLink]="User"
        class="tab"
        id="ManageUserTab"
        >
        User
      </div>
    }
  </div>
}
@if (tabs === 'users') {
  <div class="tabs">
    @if (authorizationService.canListUserIdentities()) {
      <div
        [ngClass]="{ selected: url === Users || url === '/user-identities/users/list' }"
        [routerLink]="featureService.betaListRoute(Users)"
        class="tab"
        id="ManageUsersTab"
        >
        Users
      </div>
    }
    @if (authorizationService.canListUserIdentities()) {
      <div
        [ngClass]="{ selected: url === UserRoles || url === '/user-identities/user-roles/list' }"
        [routerLink]="featureService.betaListRoute(UserRoles)"
        class="tab"
        id="UserRolesTab"
        >
        User Roles
      </div>
    }
    @if (authorizationService.canListInvitations()) {
      <div
        [ngClass]="{ selected: url === Manage_Invitations || url === '/user-identities/invitations/list' }"
        [routerLink]="featureService.betaListRoute(Manage_Invitations)"
        class="tab"
        id="ManageInvitationsTab"
        >
        Invitations
      </div>
    }
    <!-- Only a user who can read role templates sees this tab, and only in an app that does not hide it. -->
    @if (!hideRoleTemplatesTab && authorizationService.canListRoleTemplates()) {
      <div
        [ngClass]="{ selected: url === Role_Templates || url === '/user-identities/role-templates/list' }"
        [routerLink]="featureService.betaListRoute(Role_Templates)"
        class="tab"
        id="RoleTemplatesTab"
        >
        Role Templates
      </div>
    }
  </div>
}
@if (tabs === 'ca') {
  <div class="tabs">
    @if (authorizationService.canListCAs()) {
      <div
        [ngClass]="{ selected: url === Ziti_Certificate_Authorities }"
        [routerLink]="Ziti_Certificate_Authorities"
        class="tab"
        id="ManageCertificatesTab"
        >
        Certificate Authorities
      </div>
    }
    @if (authorizationService.canListJwtSigners()) {
      <div
        [ngClass]="{ selected: url === JWT_Signers }"
        [routerLink]="JWT_Signers"
        class="tab"
        id="ManageJwtSignersTab"
        >
        JWT Signers
      </div>
    }
    @if (authorizationService.canListAuthPolicies()) {
      <div
        [ngClass]="{ selected: url === Auth_Policies }"
        [routerLink]="Auth_Policies"
        class="tab"
        id="ManageAuthPoliciesTab"
        >
        Authentication Policies
      </div>
    }
  </div>
}
@if (tabs === 'reporting') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Network_Group_Summary }"
      [routerLink]="Network_Group_Summary"
      class="tab"
      id="NetworkGroupSummary"
      >
      Network Group Summary
    </div>
    <div
      [ngClass]="{ selected: url === Resource_Usage }"
      [routerLink]="Resource_Usage"
      class="tab"
      id="ResourceUsageSummary"
      >
      Resource Usage Days
    </div>
    <div [ngClass]="{ selected: url === Daily_Stats }" [routerLink]="Daily_Stats" class="tab" id="DailyStats">
      Daily Resource Stats
    </div>
    <div
      [ngClass]="{ selected: url === Daily_Endpoint_Utilization }"
      [routerLink]="Daily_Endpoint_Utilization"
      class="tab"
      id="DailyEndpointUtilization"
      >
      Daily Endpoint Utilization
    </div>
  </div>
}
@if (tabs === 'roles') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === '/roles' }" class="tab" id="ManageRolesTab" routerLink="/roles">
      Roles & Permissions
    </div>
  </div>
}
@if (tabs === 'profile') {
  <div class="tabs">
    <div [ngClass]="{ selected: url === '/profile' }" class="tab" id="ManageProfileTab" routerLink="/profile">
      Profile
    </div>
    <div
      [ngClass]="{ selected: url === '/user-settings' }"
      class="tab"
      id="UserSettingsTab"
      routerLink="/user-settings"
      >
      User Settings
    </div>
    <!-- <div class="tab" id="NotificationsButton" *ngIf="networkVersion < 7"  [routerLink]="Notifications" [ngClass]="{selected:url===Notifications}" >Manage Notifications</div> -->
  </div>
}
<!-- Ziti UI Area -->
@if (tabs === 'routers') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Edge_Routers }"
      [routerLink]="Edge_Routers"
      class="tab"
      id="ManageEdgeRouters"
      >
      Edge Routers
    </div>
    <div
      [ngClass]="{ selected: url === '/v7/policies' }"
      class="tab"
      id="ManageEdgeRouterPolicies"
      routerLink="/v7/policies"
      >
      Edge Router Policies
    </div>
    @if (featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === '/v7/service-edge-router-policies' }"
        class="tab"
        id="ManageServiceEdgeRouterPolicies"
        routerLink="/v7/service-edge-router-policies"
        >
        Service Edge Router Policies
      </div>
    }
  </div>
}
@if (tabs === 'zitiappwans') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Services }"
      [routerLink]="Ziti_Services"
      class="tab"
      id="ManageZitiServices2"
      >
      Services
    </div>
    <div
      [ngClass]="{ selected: url === Ziti_AppWans }"
      [routerLink]="Ziti_AppWans"
      class="tab"
      id="ManageZitiAppWans"
      >
      AppWANs
    </div>
    @if (this.featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === Ziti_Configs }"
        [routerLink]="Ziti_Configs"
        class="tab"
        id="ManageZitiConfigs"
        >
        Configurations
      </div>
    }
    @if (this.featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === Ziti_Config_Types }"
        [routerLink]="Ziti_Config_Types"
        class="tab"
        id="ManageZitiConfigTypes"
        >
        Configuration Types
      </div>
    }
  </div>
}
@if (tabs === 'zitiservices') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Services }"
      [routerLink]="Ziti_Services"
      class="tab"
      id="ManageZitiServices"
      >
      Manage Services
    </div>
  </div>
}
@if (tabs === 'zitiendpoints') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Endpoints }"
      [routerLink]="Ziti_Endpoints"
      class="tab"
      id="ManageZitiEndpoints"
      >
      Endpoints
    </div>
  </div>
}
@if (tabs === 'posture-checks') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Posture_Checks }"
      [routerLink]="Posture_Checks"
      class="tab"
      id="ManagePostureChecks"
      >
      Posture Checks
    </div>
  </div>
}

@if (tabs === 'ziti-identities') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Endpoints }"
      [routerLink]="Ziti_Endpoints"
      class="tab"
      id="ManageEdgeRouters"
      >
      Identities
    </div>
  </div>
}
@if (tabs === 'ziti-services') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Services }"
      class="tab"
      id="ManageEdgeRouterPolicies"
      [routerLink]="Ziti_Services"
      >
      Services
    </div>
    @if (this.featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === Ziti_Configs }"
        [routerLink]="Ziti_Configs"
        class="tab"
        id="ManageZitiConfigs"
        >
        Configurations
      </div>
    }
    @if (this.featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === Ziti_Config_Types }"
        [routerLink]="Ziti_Config_Types"
        class="tab"
        id="ManageZitiConfigTypes"
        >
        Configuration Types
      </div>
    }
  </div>
}
@if (tabs === 'ziti-ers') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Edge_Routers }"
      [routerLink]="Edge_Routers"
      class="tab"
      id="ManageServiceEdgeRouterPolicies"
      routerLink="/v7/service-edge-router-policies"
      >
      Edge Routers
    </div>
  </div>
}
@if (tabs === 'ziti-policies') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_AppWans }"
      [routerLink]="Ziti_AppWans"
      class="tab"
      id="ManageZitiAppWans"
      >
      Service Policies (AppWANs)
    </div>
    <div
      [ngClass]="{ selected: url === '/v7/policies' }"
      class="tab"
      id="ManageEdgeRouterPolicies"
      routerLink="/v7/policies"
      >
      Edge Router Policies
    </div>
    @if (featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === '/v7/service-edge-router-policies' }"
        class="tab"
        id="ManageServiceEdgeRouterPolicies"
        routerLink="/v7/service-edge-router-policies"
        >
        Service Edge Router Policies
      </div>
    }
  </div>
}
@if (tabs === 'ziti-access') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Services }"
      [routerLink]="Ziti_Services"
      class="tab"
      id="ManageZitiServices2"
      >
      Services
    </div>
    <div
      [ngClass]="{ selected: url === Ziti_AppWans }"
      [routerLink]="Ziti_AppWans"
      class="tab"
      id="ManageZitiAppWans"
      >
      AppWANs
    </div>
    @if (this.featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === Ziti_Configs }"
        [routerLink]="Ziti_Configs"
        class="tab"
        id="ManageZitiConfigs"
        >
        Configurations
      </div>
    }
    @if (this.featureService.powerUserEnabled) {
      <div
        [ngClass]="{ selected: url === Ziti_Config_Types }"
        [routerLink]="Ziti_Config_Types"
        class="tab"
        id="ManageZitiConfigTypes"
        >
        Configuration Types
      </div>
    }
  </div>
}
@if (tabs === 'ziti-visibility') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Services }"
      [routerLink]="Ziti_Services"
      class="tab"
      id="ManageZitiServices"
      >
      Manage Services
    </div>
  </div>
}
@if (tabs === 'ziti-endpoints') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Ziti_Endpoints }"
      [routerLink]="Ziti_Endpoints"
      class="tab"
      id="ManageZitiEndpoints"
      >
      Endpoints
    </div>
  </div>
}
@if (tabs === 'ziti-management' || tabs === 'ziti-posture') {
  <div class="tabs">
    <div
      [ngClass]="{ selected: url === Posture_Checks }"
      [routerLink]="Posture_Checks"
      class="tab"
      id="ManagePostureChecks"
      >
      Posture Checks
    </div>
  </div>
}
</div>
